import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ActivityTypeForm from '../../../components/forms/ActivityTypeForm';
import { useActivityTypeById, useUpdateActivityType } from '../../../hooks/useActivityTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ActivityTypeDTO } from '../../../services/apiClient';

const ActivityTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useActivityTypeById(id || '');
  const updateMutation = useUpdateActivityType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Activity Types', href: '/admin/activitytypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/activitytypes');
    } catch (error) {
      console.error('Error updating Activity Type:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/activitytypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ActivityType.Edit"
    >
      {isLoading ? (
        <p>Loading...</p>
      ) : entityData ? (
        <ActivityTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/activitytypes')}
        />
      ) : (
        <p>Activity Type not found</p>
      )}
    </AdminLayout>
  );
};

export default ActivityTypeEdit;
